//
//
//
//
//
//

import CategoryList from '../components/Category/list.vue';
export default {
  components: {
    CategoryList: CategoryList
  },
  data: function data() {
    return {
      constants: this.$constants
    };
  }
};